module.exports = __webpack_public_path__ + "img/c6.8a02a08e.png";